


//////////////////
// WEBPACK FOOTER
// ../~/node-libs-browser/mock/empty.js
// module id = 2265
// module chunks = 2